var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('comments-and-notifications',{attrs:{"id":_vm.id,"write-comments":_vm.album.is_admin || _vm.album.write_comments,"scope":"album"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }